import { render, staticRenderFns } from "./Ucloud.vue?vue&type=template&id=2fd89b2d&"
import script from "./Ucloud.vue?vue&type=script&lang=js&"
export * from "./Ucloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports